import React from 'react';
import { useLocale } from '../i18n';

interface CommentBoxProps {
  comment: string;
}

const CommentBox: React.FC<CommentBoxProps> = ({ comment }) => {
  const { t } = useLocale();
  return (
    <div style={{ padding: '16px', overflowY: 'auto', backgroundColor: '#f8f9fa', height: '100%', boxSizing: 'border-box' }}>
      {comment ? (
        <p style={{ whiteSpace: 'pre-wrap', margin: 0, fontSize: '14px' }}>{comment}</p>
      ) : (
        <p style={{ color: '#6c757d', margin: 0, textAlign: 'center', paddingTop: '20px' }}>{t('noComment')}</p>
      )}
    </div>
  );
};

export default CommentBox;
